module.exports = __webpack_public_path__ + "static/img/02_05.8a5248d6.jpg";